import { useEffect } from 'react';
import { useVoiceActivity } from 'hooks/useVoiceActivity';
import { VoiceActivityDetector } from './VoiceActivityDetector';

interface VoiceActivityStreamDetectorProps {
  /**
   * Колбэк должен вернуть актуальный MediaStream на момент старта записи.
   * Стрим обычно живёт в ref (videoRef.current.srcObject), поэтому пробрасываем геттер.
   */
  getStream: () => MediaStream | null;
  isRecording: boolean;
  hideIcon?: boolean;
}

/**
 * Самоуправляемый детектор голоса для страниц с записью.
 * Изолирует 60fps setState от родительской страницы — ре-рендерится только это поддерево.
 */
export const VoiceActivityStreamDetector = ({
  getStream,
  isRecording,
  hideIcon = false
}: VoiceActivityStreamDetectorProps) => {
  const { voiceVolume, startAnalysis, stopAnalysis } = useVoiceActivity();

  useEffect(() => {
    if (isRecording) {
      const stream = getStream();
      if (stream) {
        startAnalysis(stream);
      }
    } else {
      stopAnalysis();
    }
    // getStream намеренно вне deps: читаем его императивно на переходе isRecording
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecording, startAnalysis, stopAnalysis]);

  return (
    <VoiceActivityDetector volume={voiceVolume} isRecording={isRecording} hideIcon={hideIcon} />
  );
};
